export default __webpack_public_path__ + "static/media/img_background_slide_one.2358a67c.png";